import { useMemo } from 'react';

const useCustomAggFuncs = (columns, initialColumnDefs) => {
  return useMemo(() => {
    const dateTimeColumns = columns.filter(c => ['date', 'datetime'].includes(c.data_type));

    const customAggFuncs = {
      ...Object.fromEntries(dateTimeColumns.map(c => [`lastBy${c.accessor} (${c.name})`, () => {}])),
      ...Object.fromEntries(
        initialColumnDefs
          .filter(col => col.enableRowGroup)
          .map(col => [
            `copyMinTo${col.field} (${col.headerName})`, () => {}
          ])
      ),
    };

    return customAggFuncs;
  }, [initialColumnDefs, columns]);
};

export default useCustomAggFuncs;
